import { render, staticRenderFns } from "./officialStamp.vue?vue&type=template&id=451d9215"
import script from "./officialStamp.vue?vue&type=script&lang=js"
export * from "./officialStamp.vue?vue&type=script&lang=js"
import style0 from "./officialStamp.vue?vue&type=style&index=0&id=451d9215&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports